import React, { Fragment, useEffect, useRef, useState } from "react";
import {
    AppBar,
    Grid,
    TextField,
    Box,
    Paper,
    Tab,
    Tabs,
    Typography,
    makeStyles,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    withStyles,
    Button,
} from "@material-ui/core";
import PropTypes from "prop-types";
import HttpService from "../../services/httpService";
import { setLoading } from "../../redux/actions/appAction";
import { connect, useSelector } from "react-redux";
import { Modal } from "antd";
import moment from "moment";
import { CSVLink } from "react-csv";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { DownloadOutlined } from '@ant-design/icons';
import {
    CONST_USER_ID,
    PalaPrasanthKumarId,
    PalisettiTejaId,
    ROLENAME,
    SriKrishnaId,
    ThirumaleshId,
} from "../../utils";
import { Link } from 'react-router-dom'


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        "& > *": {
            margin: theme.spacing(1),
        },
    },
    // table: {
    //  maxWidth:"67vw",
    // },
    tablecontainer: {
        display: "flex",
        margin: "25px",
    },
    customTableContainer: {
        overflowX: "initial",
    },
    tableform: {
        display: "flex",
        maxWidth: "68vw",
        textAlign: "center"
    },
    paper: {
        padding: theme.spacing(2),
        margin: "auto",
        maxWidth: 400,
    },
    clickableTableCell: {
        cursor: "pointer",
        textDecoration: "underline",
        color: "blue",
    },
    normalTableCell: {
        color: "black",
        "&:hover": {
            cursor: "pointer",
            color: "blue", // you can change the color when hovering here
            textDecoration: "underline",
        },
    },
    tableCell: {
        color: "blue",
        cursor: "pointer",
        textDecoration: "underline",

        // Changing color, cursor and textDecoration on hovering
        // "&:hover": {
        // 	cursor: "pointer",
        // 	color: "blue", // you can change the color when hovering here
        // 	textDecoration: "underline",
        // },
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    narrowTab: {
        minWidth: "fit-content", // Adjust the width as needed
        // width:"fit-content",
        width: 65,
    },
    margin: {
        margin: theme.spacing(1),
    },
    activeButton: {
        backgroundColor: "#F50057 !important",
        color: "white !important",
        transition: "background-color 0.3s, color 0.3s",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '6px 20px',
        whiteSpace: 'nowrap',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '6px 20px',
        whiteSpace: 'nowrap',
    },
    submitButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '6px 20px',
        whiteSpace: 'nowrap',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    dateFilterContainer: {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        marginBottom: "20px",
      },
    downloadButton: {
        backgroundColor: "#355025",
        color: "#FFF2EB",
        marginLeft: "10px",
        whiteSpace: 'nowrap',
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color: '#FFF2EB',
        fontWeight: "500",
        width: "102%"
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const ProductionSummary = (props) => {
    const classes = useStyles();
    const [value, setValue] = useState("");
    const { userDetails } = useSelector((state) => state.user);
    const [materialDeliveryData, setMaterialDeliveryData] = useState([]);
    const [underExecutionData, setUnderExecutionData] = useState([]);
    const [projectCompetionData, setProjectCompletionData] = useState([]);
    const [completedMwpData, setCompletedMwpData] = useState([]);
    const [factoryStageData, setFactoryStageData] = useState([]);
    const [factoryDataForOps1, setFactoryDataForOps1] = useState([]);
    const [completedProjectData, setCompletedProjectData] = useState([]);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [detailDataArray, setDetailDataArray] = useState([]);
    const [title, setTitle] = useState("Dummy Title");
    const [csvData, setCsvData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const csvButtonRef = useRef(null);
    const [ShowDesignSignOffRevokeDate, setShowDesignSignOffRevokeDate] = useState(false)
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const [productionTableCsvData, setProductionTableCsvData] = useState([]);
    const productionTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [showTATColumns, setShowTATColumns] = useState(false);
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    // Set your database start date here (the date when data collection started)
    const databaseStartDate = "2025-11-11"; 
    // Date range configuration
    const minAllowedDate = databaseStartDate; // No data before this date
    const maxAllowedDate = moment().subtract(1, 'day').format('YYYY-MM-DD'); // No data for today and future
        
    // Default to yesterday, but ensure it's not before database start date
    const defaultDate = moment(maxAllowedDate).isAfter(minAllowedDate) 
            ? maxAllowedDate 
            : minAllowedDate;
        
    const [exportDate, setExportDate] = useState(defaultDate);
    const [isTableDateFiltered, setIsTableDateFiltered] = useState(false);

    let includeExperienceCenter = detailDataArray.some(item => item.experienceCenterName !== "" && item.experienceCenterName !== null && item.experienceCenterName !== undefined);
    let includeFactoryBomCompletedDate = detailDataArray.some(item => item.factoryBomCompletedDate !== "" && item.factoryBomCompletedDate !== null && item.factoryBomCompletedDate !== undefined);
    let includeRevocationDate = detailDataArray.some(item => item.designSignoffRevokeDate !== "" && item.designSignoffRevokeDate !== null && item.designSignoffRevokeDate !== undefined);
    let includedesignerAndAdmName = detailDataArray.some(item => item.designManagerName !== "" && item.designManagerName !== null && item.designManagerName !== undefined);
    let includeChmName = detailDataArray.some(item => item.chmUserName !== "" && item.chmUserName !== null && item.chmUserName !== undefined);
    let includeCustomerName = detailDataArray.some(item => item.customerName !== "" && item.customerName !== null && item.customerName !== undefined);
    let includeCustomerAddress = detailDataArray.some(item => item.customerAddress !== "" && item.customerAddress !== null && item.customerAddress !== undefined);
    let includeContractQualityControlApproved = detailDataArray.some(item => item.contractQualityControlApproved !== "" && item.contractQualityControlApproved !== null && item.contractQualityControlApproved !== undefined);
    let includeContractQCManagerApproved = detailDataArray.some(item => item.contractQCManagerApproved !== "" && item.contractQCManagerApproved !== null && item.contractQCManagerApproved !== undefined);
    let includeContractDesignManagerApproved = detailDataArray.some(item => item.contractDesignManagerApproved !== "" && item.contractDesignManagerApproved !== null && item.contractDesignManagerApproved !== undefined);
    let includeContractCustomerApproved = detailDataArray.some(item => item.contractCustomerApproved !== "" && item.contractCustomerApproved !== null && item.contractCustomerApproved !== undefined);
    let includeContractFinanceApproved = detailDataArray.some(item => item.contractFinanceApproved !== "" && item.contractFinanceApproved !== null && item.contractFinanceApproved !== undefined);
    let includeMaterialDeliveryDate = detailDataArray.some(item => item.materialDispatchedDate !== "" && item.materialDispatchedDate !== null && item.materialDispatchedDate !== undefined);
    let includeActualCompletionDate = detailDataArray.some(item => item.executionCompletionDate !== "" && item.executionCompletionDate !== null && item.executionCompletionDate !== undefined);
    let includeExecutionMWPDate = detailDataArray.some(item => item.executionMWPDate !== "" && item.executionMWPDate !== null && item.executionMWPDate !== undefined);

    // Headers for csv file
    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNo", label: "Lead No" },
        { key: "currentStage", label: "Stage" },
        { key: "departmentName", label: "Department" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "cityName", label: "City Name" },
        { key: "salesWonDate", label: "Sales Won Date" },
        { key: "designSignOffDate", label: "Design Sign-Off Date" },
    ];

    if (includeExperienceCenter) {
        headers.push({ key: "experienceCenter", label: "Experience Center" });
    }
    if (includeFactoryBomCompletedDate) {
        headers.push({ key: "factoryBomCompletedDate", label: "Factory Assignment Date" });
    }
    if (includeRevocationDate) {
        headers.push({ key: "revocationDate", label: "Design-Hold Revoke Date" });
    }
    if (includedesignerAndAdmName) {
        headers.push({ key: "designerAndAdmName", label: "Designer/ADM name" });
    }
    if (includeChmName) {
        headers.push({ key: "chmName", label: "CHM Name" });
    }
    if (includeCustomerName) {
        headers.push({ key: "customerName", label: "Customer name" });
    }
    if (includeContractQualityControlApproved) {
        headers.push({ key: "contractQualityControlApproved", label: "QC Approval" });
    }
    if (includeContractQCManagerApproved) {
        headers.push({ key: "contractQCManagerApproved", label: "QC Manager Approval" });
    }
    if (includeContractDesignManagerApproved) {
        headers.push({ key: "contractDesignManagerApproved", label: "ADM Approval" });
    }
    if (showTATColumns) {
        headers.push({ key: "materialDeliveryDate", label: "Material Dispatch Date" });
        headers.push({ key: "tat", label: "Expected TAT" });
        headers.push({ key: "delayedDays", label: "No of Days Delayed" });
    }
    
    if (includeContractCustomerApproved) {
        headers.push({ key: "contractCustomerApproved", label: "Customer Approval" });
    }
    if (includeContractFinanceApproved) {
        headers.push({ key: "contractFinanceApproved", label: "Finance Approval" });
    }
    if (includeMaterialDeliveryDate) {
        headers.push({ key: "materialDeliveryDate", label: "Material Delivery Date" });
    }
    if (includeActualCompletionDate) {
        headers.push({ key: "actualCompletionDate", label: "Actual Completion Date" });
    }
    if (includeExecutionMWPDate) {
        headers.push({ key: "executionMWPDate", label: "MWP Completion Date" });
    }
    if (includeCustomerAddress) {
        headers.push({ key: "apartmentName", label: "Apartment Name" });
    }

    const formatToLakhs = (value) => {
        const valueInLakhs = value / 100000;
        return valueInLakhs.toLocaleString("en-IN", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        });
    };
    // Function to handle tab changes
    const handleChange = (newValue) => {
        setValue(newValue);
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
    };

    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }

    const handleSearch = async (diffValue) => {
        getFactoryManagerDataStageWise(selectedSearchType, searchInput);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };
    
    // Pass useDateFilter=true to source the table from the archived factory
    // snapshot for the selected date instead of live lead data.
    const getFactoryManagerDataStageWise = async (selectedSearchType, searchInput, useDateFilter) => {
        props.setLoading(true);
        let obj = {
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        if (useDateFilter && exportDate) {
            obj.startDate = exportDate;
            obj.endDate = exportDate;
        }
        try {
            const response = await HttpService.getFactoryStageData(obj);
            setFactoryStageData(response.data);
            if (useDateFilter && response?.data?.length === 0) {
                props?.setSnackInfo("No data found for the selected date", "warning");
            }
        } catch (error) {
            console.log("Error Here ->", error);
            props?.setSnackInfo("Failed to load table data for the selected date", "error");
        }
        props.setLoading(false);
    };


    // Function to show Details
    const showDetailedModalHandler = (data, text) => {
        try {
            let call = data.map((el) => el.currentStage);
            let checkStage = call.every((el) => el === 'Design Sign-off HOLD');
            setShowDesignSignOffRevokeDate(checkStage)
            setShowDetailedModal(true);
            setTitle(text);
            setDetailDataArray(data);
        } catch (error) {
            console.log("Error - ", error);
        }
    };

    // Validates the selected date, then refreshes the Stages table to show archived data for that day.
    const handleSubmitDate = () => {
        if (!exportDate) {
            props?.setSnackInfo("Please select a date", "error");
            return;
        }
        setIsTableDateFiltered(true);
        getFactoryManagerDataStageWise(selectedSearchType, searchInput, true);
    };

    // Resets the date back to the default (yesterday) and switches the Stages table back to live data.
    const handleClearDate = () => {
        setExportDate(defaultDate);
        if (isTableDateFiltered) {
            setIsTableDateFiltered(false);
            getFactoryManagerDataStageWise(selectedSearchType, searchInput, false);
        }
    };


    const handleDownloadExcel = async () => {
        if (!exportDate) {
            if (props?.setSnackInfo) {
                props.setSnackInfo("Please select a date", "error");
            }
            return;
        }
        try {
            props.setLoading(true);

            // Call your backend API to get Excel file
            const response = await HttpService.exportProductionData(exportDate, exportDate);

            if (response.status === 200) {
                // Create blob from response
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                // Create download link
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                const fileNameSuffix = exportDate.replace(/-/g, '_');
                link.setAttribute('download', `Production_data_${fileNameSuffix}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                if (props?.setSnackInfo) {
                    props.setSnackInfo("Excel file downloaded successfully!", "success");
                }
            } else {
                // Handle non-200 responses
                if (props?.setSnackInfo) {
                    props.setSnackInfo(
                        response?.data?.message || "Failed to download Excel file", 
                        "error"
                    );
                }
            }
            
        } catch (error) {
            console.error('Error downloading Excel file:', error);
            
            // Handle error with proper error message
            if (props?.setSnackInfo) {
                props.setSnackInfo(
                    error?.response?.data?.message || 
                    error?.message || 
                    "Failed to download Excel file", 
                    "error"
                );
            }
        } finally {
            props.setLoading(false);
        }
    };
    // Function to download csv
    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < detailDataArray.length; i++) {
                let data = detailDataArray[i];
                let obj = {
                    serialNo: i + 1,
                    projectCode: data?.erpProjectNo || "N/A",
                    leadNo: data?.lead_no,
                    currentStage: data?.currentStage,
                    departmentName: data?.departmentName,
                    totalValue: data?.grandTotal ? (data.grandTotal / 1.18).toFixed(2) : "-",
                    cityName: data?.cityName,
                    salesWonDate: data?.leadWonDate
                        ? moment(data.leadWonDate).format("DD-MM-YYYY")
                        : "-",
                    designSignOffDate: data?.customerDesignSignOffDate
                        ? moment(data.customerDesignSignOffDate).format("DD-MM-YYYY")
                        : "-",
                    materialDeliveryDate: data?.materialDispatchedDate
                        ? moment(data.materialDispatchedDate).format("DD-MM-YYYY")
                        : "-",
                    actualCompletionDate: data?.executionCompletionDate
                        ? moment(data.executionCompletionDate).format("DD-MM-YYYY")
                        : "-",
                    executionMWPDate: data?.executionMWPDate
                        ? moment(data.executionMWPDate).format("DD-MM-YYYY")
                        : "-",
                    designerAndAdmName: `${data?.designUserName || ""} / ${data?.designManagerName || ""}`,
                    apartmentName: data?.customerAddress,
                    customerName: data?.customerName,
                    chmName: data?.chmUserName,
                    factoryBomCompletedDate: data?.factoryBomCompletedDate
                        ? moment(data.factoryBomCompletedDate).format("DD-MM-YYYY")
                        : "-",
                    revocationDate: data?.designSignoffRevokeDate
                        ? moment(data.designSignoffRevokeDate).format("DD-MM-YYYY")
                        : "-",
                    experienceCenter: data?.experienceCenterName,
                    contractQualityControlApproved: data?.contractQualityControlApproved,
                    contractQCManagerApproved: data?.contractQCManagerApproved,
                    contractDesignManagerApproved: data?.contractDesignManagerApproved,
                    contractCustomerApproved: data?.contractCustomerApproved,
                    contractFinanceApproved: data?.contractFinanceApproved
                };
        
                if (showTATColumns) {
                    obj.materialDeliveryDate = data?.materialDispatchedDate
                        ? moment(data.materialDispatchedDate).format("DD-MM-YYYY")
                        : "-";
                    obj.tat = data?.tat || "NA";
                    obj.delayedDays = data?.tat ? (data.delayedDays ?? "NA") : "NA";
                }
        
                csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

        // Trigger CSV download when data is ready
        useEffect(() => {
            if (triggerDownload && productionTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (productionTableCsvButtonRef.current?.link) {
                        try {
                            productionTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props?.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerDownload(false);
                    } else {
                        // Retry if link is not ready
                        setTimeout(() => {
                            if (productionTableCsvButtonRef.current?.link) {
                                productionTableCsvButtonRef.current.link.click();
                                setTriggerDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                
                return () => clearTimeout(timer);
            }
        }, [triggerDownload, productionTableCsvData]);
    
        // Function to generate CSV data for production summary table
        const generateProductionTableCsvData = () => {
            try {
                if (!factoryStageData || factoryStageData.length === 0 || !factoryStageData[0]?.stageData) {
                    return [];
                }
    
                const csvRows = [];
    
                // Build header row - match table structure exactly
                const headerRow = {
                    "Stages": ""
                };
    
                // Add location columns
                factoryStageData.forEach((el) => {
                    if (el?.locationDetail?.locationName) {
                        headerRow[el.locationDetail.locationName] = "";
                    }
                });
                csvRows.push(headerRow);
    
                // Add data rows for each stage (excluding "Material Dispatched (In-transit)" to match table)
                factoryStageData[0].stageData.forEach((stageEl) => {
                    // Skip "Material Dispatched (In-transit)" stage to match table display
                    if (stageEl?.stage === "Material Dispatched (In-transit)") {
                        return;
                    }
    
                    const row = {
                        "Stages": stageEl?.stage || ""
                    };
    
                    // Add value for each location
                    factoryStageData.forEach((data) => {
                        const stageData = data?.stageData?.find(
                            (sd) => sd?.stage === stageEl?.stage
                        );
                        if (data?.locationDetail?.locationName) {
                            row[data.locationDetail.locationName] = stageData?.value || 0;
                        }
                    });
    
                    csvRows.push(row);
                });
    
                return csvRows;
            } catch (error) {
                console.error("Error generating production table CSV:", error);
                return [];
            }
        };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };

    // Function verify User
    // const verifyDataVisibilityAccess = () => {
    // 	if (
    // 		findMatchingUser(userDetails?._id) ||
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.DataAnalyst || role.name === ROLENAME.FinanceManager
    // 		)
    // 	) {
    // 		setValue("Summary of Delivery");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.SeniorOperationManager || role.name === ROLENAME.Admin
    // 		)
    // 	) {
    // 		setValue("Ops-1");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) => role.name === ROLENAME.FactoryManager
    // 		) &&
    // 		userDetails?._id.toString() !== ThirumaleshId
    // 	) {
    // 		setValue("Ops-2 (Factory)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops ||
    // 				role.name === ROLENAME.Execution_Manager
    // 		) ||
    // 		userDetails?._id === SriKrishnaId
    // 	) {
    // 		setValue("Ops-3 (Execution)");
    // 	} else if (
    // 		userDetails?.roles.find(
    // 			(role) =>
    // 				role.name === ROLENAME.DGM_Ops || role.name === ROLENAME.ExecutionUser
    // 		) ||
    // 		userDetails?._id === PalisettiTejaId ||
    // 		userDetails?._id === PalaPrasanthKumarId
    // 	) {
    // 		setValue("Ops-3 (MWP)");
    // 	}
    // };

    // const dateFilterHandler = () => {
    // 	if (value === "Summary of Delivery")
    // 		getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	if (value === "Summary of Completion")
    // 		getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	if (value === "Stage-Value") {
    // 		getMaterialDeliveryDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 		getProjectCompletionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 		getFactoryManagerDataForOps1Tab(selectedSearchType, searchInput);
    // 		getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	} else if (value === "Ops-3 (Execution)") {
    // 		getUnderExecutionDataCityWise(startDate, endDate, selectedSearchType, searchInput);
    // 	}
    // };

    const clearDateFilter = () => {
        setStartDate("");
        setEndDate("");
        setSearchInput("")
        setSelectedSearchType("")
        getFactoryManagerDataStageWise("", "");
    };

    useEffect(() => {
        // verifyDataVisibilityAccess();
        getFactoryManagerDataStageWise();
    }, []);
    return (
        <Fragment>
            <Fragment>
                <Paper style={{ padding: 10, marginLeft: 25 }}>
                      {/* Date Filter Section */}
                      <div className={classes.dateFilterContainer}>
                            <TextField
                                label="Select Date"
                                type="date"
                                value={exportDate}
                                onChange={(e) => setExportDate(e.target.value)}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    min: minAllowedDate,
                                    max: maxAllowedDate,
                                }}
                                style={{ width: '200px' }}
                            />

                        <Button
                            variant="contained"
                            size="medium"
                            className={classes.submitButton}
                            onClick={handleSubmitDate}
                            disabled={!exportDate}
                        >
                            Submit Date
                        </Button>

                        <Button
                            variant="contained"
                            size="medium"
                            className={classes.leadClearButton}
                            onClick={handleClearDate}
                        >
                            Clear Date
                        </Button>

                            <Button
                                variant="contained"
                                size="medium"
                                className={classes.downloadButton}
                                onClick={handleDownloadExcel}
                                disabled={!exportDate}
                            >
                                Download CSV
                            </Button>
                      </div>  
                    <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginTop: '30px' }}>
                                            
                        {/* Search Type Dropdown */}
                        <TextField
                            select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={selectedSearchType}
                            label="Search Type"
                            name="searchType"
                            onChange={(e) => handleSearchType(e.target.value)}
                            variant="outlined"
                            style={{ width: '180px', marginRight: '10px', flexShrink: 0 }}
                            size="small"
                        >
                            {searchTypes && searchTypes?.map((el, index) => (
                                <MenuItem key={index} value={el}>{el}</MenuItem>
                            ))}
                        </TextField>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ flex: 1, minWidth: 0 }}
                        />

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{ marginLeft: 10, flexShrink: 0 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10, flexShrink: 0 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>

                        {/* Download Table Data — same line as the filters above */}
                        <CSVLink
                            data={productionTableCsvData}
                            filename={`Production_Summary_${moment().format('YYYY-MM-DD')}.csv`}
                            ref={productionTableCsvButtonRef}
                            style={{ textDecoration: 'none', display: 'none' }}
                        />
                        <Button
                            variant='contained'
                            startIcon={<DownloadOutlined />}
                            style={{ flexShrink: 0 }}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const csvData = generateProductionTableCsvData();

                                if (csvData.length > 0) {
                                    setProductionTableCsvData(csvData);
                                    setTimeout(() => {
                                        setTriggerDownload(true);
                                    }, 100);
                                } else {
                                    props?.setSnackInfo("No data available to export", "warning");
                                }
                            }}
                            className={classes.downloadButton}
                        >
                            Download Table Data
                        </Button>
                    </div>
                </Paper>
                
                {isTableDateFiltered && (
                    <div style={{ marginLeft: 25, marginTop: 15, fontSize: 13, color: '#555' }}>
                        Showing archived data for{' '}
                        <b>{moment(exportDate).format('DD-MM-YYYY')}</b>
                        {' '}(not live data) — click "Clear Date" to go back to live data.
                    </div>
                )}

                <div
                    className={classes.tablecontainer}
                    style={{ marginLeft: 25 }}
                >
                    <div className={classes.tableform}>
                        <div style={{ maxHeight: '600px', overflow: 'auto' }}>

                            <TableContainer component={Paper}
                                className={classes.table}
                                style={{ width: "100%" }}
                                classes={{ root: classes.customTableContainer }}>

                                <Table style={{ width: 450 }}
                                    className={classes.table}
                                    stickyHeader
                                    aria-label="sticky table">
                                    <TableHead style={{ position: 'sticky', top: 0, zIndex: 9, background: 'white' }}>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ position: 'sticky', left: 0, zIndex: 9 }}>
                                                Stages</StyledTableCell>
                                            {factoryStageData?.map((el) => {
                                                return (
                                                    <StyledTableCell
                                                        style={{
                                                            zIndex: 2,
                                                            fontWeight: `${el?.locationDetail?.locationName ===
                                                                "Grand Total"
                                                                ? "700"
                                                                : ""
                                                                }`,
                                                        }}
                                                    >
                                                        {el?.locationDetail?.locationName}
                                                    </StyledTableCell>
                                                );
                                            })}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableHead style={{ position: 'sticky', top: 0 }}>
                                    {factoryStageData[0]?.stageData?.map((el, i) => {
                                            return (<>
                                                {el?.stage!=="Material Dispatched (In-transit)" && <StyledTableRow key={i}>
                                                    <StyledTableCell
                                                        style={{
                                                            position: "sticky",
                                                            left: 0,
                                                            zIndex: 9,
                                                            fontWeight: `${el?.stage === "Grand Total" ? "700" : ""
                                                                }`,
                                                        }}
                                                        component="th"
                                                    >
                                                        {el?.stage}
                                                    </StyledTableCell>
                                                    {factoryStageData.map((data, j) => {
                                                        return (
                                                            <StyledTableCell
                                                                style={{
                                                                    zIndex: 1,
                                                                    background: "white",
                                                                    color: "black",
                                                                    fontWeight: `${el?.stage === "Grand Total" ||
                                                                        data?.locationDetail?.locationName ===
                                                                        "Grand Total"
                                                                        ? "700"
                                                                        : ""
                                                                        }`,
                                                                }}
                                                                component="th"
                                                                className={classes.tableCell}
                                                                onClick={() => {
                                                                    const isMatInTransit = data?.stageData[i]?.stage === "Material Dispatched (In-transit)" || 
                                                                                        data?.stageData[i]?.stage === "Ops-2 Factory";
                                                                    
                                                                    // Set the state to show/hide TAT columns
                                                                    setShowTATColumns(isMatInTransit);
                                                                    // Call your existing modal handler
                                                                    showDetailedModalHandler(
                                                                        data?.stageData[i].data,
                                                                        "Ops-2 Factory" +
                                                                        " | " +
                                                                        data?.stageData[i]?.stage
                                                                    );
                                                                }}
                                                            >
                                                                {data?.stageData[i]?.value}
                                                            </StyledTableCell>
                                                        );
                                                    })}
                                                </StyledTableRow>} </>
                                            );
                                        })}
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </div>
                    </div>
                </div>
            </Fragment>
            <Modal
                title={title}
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename={title.replace("|", "-") + ".csv"}
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(null)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>

                {detailDataArray && (
    <TableContainer component={Paper} className={classes.table}>
        <Table
            style={{ width: 450 }}
            className={classes.table}
            stickyHeader
            aria-label="sticky table"
        >
            <TableHead>
                <StyledTableRow>
                    <StyledTableCell>Sl. No.</StyledTableCell>
                    <StyledTableCell>Project No.</StyledTableCell>
                    <StyledTableCell>Lead No.</StyledTableCell>
                    <StyledTableCell>Stage</StyledTableCell>
                    <StyledTableCell>Department</StyledTableCell>
                    <StyledTableCell>Value (INR)</StyledTableCell>
                    <StyledTableCell>City</StyledTableCell>
                    <StyledTableCell>Experience Center</StyledTableCell>
                    <StyledTableCell>Sales Won Date</StyledTableCell>
                    <StyledTableCell>Design Sign-Off Date</StyledTableCell>
                    {showTATColumns &&<StyledTableCell>Material Dispatched Date</StyledTableCell>}
                    {showTATColumns && <StyledTableCell>Expected TAT</StyledTableCell>}
                    {showTATColumns && <StyledTableCell>No of Days Delayed</StyledTableCell>}
                    {ShowDesignSignOffRevokeDate && <StyledTableCell>Unique Lead ID</StyledTableCell>}
                    {ShowDesignSignOffRevokeDate && <StyledTableCell>Design Sign-off HOLD Revoke Date</StyledTableCell>}
                    <StyledTableCell>Designer/ADM name</StyledTableCell>
                    <StyledTableCell>Apartment Name</StyledTableCell>
                    <StyledTableCell>Current stage</StyledTableCell>
                    <StyledTableCell>Customer name</StyledTableCell>
                </StyledTableRow>
            </TableHead>
            <TableBody>
                {detailDataArray?.map((data, i) => {
                    return (
                        <StyledTableRow key={i}>
                            <StyledTableCell component="th">{i + 1}</StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {
                                    data.erpProjectNo ?
                                        <Link to={`/project-logs/${data?._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.erpProjectNo}</Link> :
                                        'NA'
                                }
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {
                                    data.lead_no ?
                                        <Link to={`/project-logs/${data._id}`} target="_blank" rel="noopener noreferrer" style={{ color: "#000", textDecoration: 'underline', textAlign: 'center' }}>  {data.lead_no}</Link> :
                                        'NA'
                                }
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.currentStage}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.departmentName}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {(data?.grandTotal / 1.18)?.toLocaleString("en-IN", {
                                    maximumFractionDigits: 2, // Maximum number of decimal places
                                    style: "currency",
                                    currency: "INR",
                                })}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.cityName || "N/A"}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.experienceCenterName || "N/A"}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.leadWonDate
                                    ? moment(data?.leadWonDate).utc().format("DD-MM-YYYY")
                                    : "-"}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.customerDesignSignOffDate
                                    ? moment(data?.customerDesignSignOffDate)
                                        .utc()
                                        .format("DD-MM-YYYY")
                                    : "-"}
                            </StyledTableCell>

                            {showTATColumns && <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.materialDispatchedDate
                                    ? moment(data?.materialDispatchedDate)
                                        .utc()
                                        .format("DD-MM-YYYY")
                                    : "NA"}
                            </StyledTableCell>}

                            {showTATColumns && <StyledTableCell
                                component="th"
                                style={{ 
                                    textAlign: "center",
                                    backgroundColor: (data?.tatBreach && data?.delayedDays > 0) ? '#ffebee' : 'inherit',
                                    color: (data?.tatBreach && data?.delayedDays > 0) ? '#c62828' : 'inherit'
                                }}
                            >
                                {data?.tat ? data?.tat : "NA"}
                            </StyledTableCell>}

                            {showTATColumns && <StyledTableCell
                                component="th"
                                style={{ 
                                    textAlign: "center",
                                    backgroundColor: (data?.tatBreach && data?.delayedDays > 0) ? '#ffebee' : 'inherit',
                                    color: (data?.tatBreach && data?.delayedDays > 0) ? '#c62828' : 'inherit'
                                }}
                            >
                                {data?.tat ? data?.delayedDays : "NA"}
                            </StyledTableCell>}
                            
                            {ShowDesignSignOffRevokeDate && <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.uniqueLeadNumber}
                            </StyledTableCell>}
                            {ShowDesignSignOffRevokeDate && <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.designSignoffRevokeDate
                                    ? moment(data?.designSignoffRevokeDate)
                                        .utc()
                                        .format("DD-MM-YYYY")
                                    : "-"}
                            </StyledTableCell>}
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.designUserName || "N/A"}
                                {" / "}
                                {data?.designManagerName || "N/A"}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.customerAddress || "N/A"}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.currentStage || "N/A"}
                            </StyledTableCell>
                            <StyledTableCell
                                component="th"
                                style={{ textAlign: "center" }}
                            >
                                {data?.customerName || "N/A"}
                            </StyledTableCell>
                        </StyledTableRow>
                    );
                })}
            </TableBody>
        </Table>
    </TableContainer>
)}
            </Modal>
        </Fragment>
    );
};

export default connect(null, { setLoading })(ProductionSummary);